import React from "react";
import { Field } from "react-final-form";
import PropTypes from "prop-types";
import { AnimatePresence } from "framer-motion";
import Fade from "../animate/Fade";

const ConditionalField = ({ when, is, isNot, children, ...rest }) => (
  /* eslint-disable react/jsx-props-no-spreading */
  <AnimatePresence>
    <Field name={when} subscription={{ value: true }} {...rest}>
      {({ input: { value } }) => (
        <Fade show={isNot === null ? value === is : value !== isNot}>
          {children}
        </Fade>
      )}
    </Field>
  </AnimatePresence>
);

ConditionalField.defaultProps = {
  isNot: null,
  is: null,
};

ConditionalField.propTypes = {
  when: PropTypes.string.isRequired,
  is: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  isNot: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  children: PropTypes.node.isRequired,
};

export default ConditionalField;
